<template lang="pug">
.case-collection
  nav(ref="caseNav")
    .categories
      label 行业
      .category
        .type
          .label(
            v-for="(c, i) in focusIndustryList",
            :key="i",
            @click.prevent="changeIndustry(c)"
          )
            span(:class="{ active: c === industry }") {{ c }}
    .categories
      label 风险
      .category
        .type
          .label(
            v-for="(c, i) in focusCategoryList",
            :key="i",
            @click.prevent="changeCategory(c)"
          )
            span(:class="{ active: c === category }") {{ c }}
  section.collect-content
    article
      CaseCollectionList(:lists="lists")
      .loading(v-if="pages.now < pages.sum")
        span(@click.prevent="loadingMore") 查看更多
      .loading(v-if="loading")
        loader
    //- aside
    //-   p.label 时间
    //-   .times(
    //-     v-for="(t, i) in times",
    //-     :key="i",
    //-     :class="{ active: t.name === time }",
    //-     @click.prevent="time = t.name"
    //-   ) {{ t.name }}
</template>

<script>
import client from '../server/server'
import moment from 'moment'
import _ from 'lodash'
import Loader from '../components/Loader'
import DataNull from '../components/DataNull'
import CaseCollectionList from './CaseCollectionList.vue'
export default {
  name: 'CaseCollection',
  components: {
    Loader,
    DataNull,
    CaseCollectionList
  },
  data () {
    return {
      times: [],
      time: '',
      category: '',
      industry: [],
      lists: [],
      loading: false,
      pages: {
        now: 1,
        sum: 1
      }
    }
  },
  mounted () {
    // this.getCondition()
    this.category = this.focusCategoryList[0]
    this.getList()
  },
  computed: {
    compareIds () {
      return this.$store.getters.compareIds
    },
    focusIndustryList () {
      return this.$store.state.user.userinfo.focusIndustryList
    },
    focusCategoryList () {
      return this.$store.state.user.userinfo.focusCategoryList
    }
  },
  watch: {
    time () {
      this.pages.now = 1
      this.getList()
    },
    compareIds: {
      deep: true,
      handler (val) {
        this.lists = this.lists.map(d => {
          return Object.assign({}, d, {
            vs: !!val.find(m => m.id === d.id)
          })
        })
      }
    }
  },
  methods: {
    changeCategory (value) {
      this.industry = ''
      this.category = value
      this.pages.now = 1
      this.getList()
    },
    changeIndustry (value) {
      this.category = ''
      this.industry = value
      this.pages.now = 1
      this.getList()
    },
    getCondition () {
      client.getEventsCondition()
        .then(res => {
          if (res.success) {
            this.times = res.data.times
            this.time = this.times[0].name
            this.categories = res.data.categories
          }
        })
    },
    getList () {
      let params = {
        page: this.pages.now,
        size: 10
        // startTime: this.times.find(d => d.name === this.time).startTime,
        // endTime: this.times.find(d => d.name === this.time).endTime,
      }
      if (this.category) {
        params.category = this.category
      }
      if (this.industry) {
        params.industry = this.industry
      }
      if (params.page === 1) {
        this.lists = []
      }
      this.loading = true
      client.getCaseCollection(params)
        .then(res => {
          if (res.success) {
            let tmp = res.data.list.map(d => {
              return Object.assign({}, d, {
                startTime: moment(d.startTime).format('YYYY/MM/DD'),
                brands: [d.priBrand].concat(d.secBrands),
                categories: d.priCrisisTags.concat(d.secCrisisTags)
              })
            })
            if (this.pages.now === 1) {
              this.lists = [...tmp]
            } else {
              this.lists = this.lists.concat(tmp)
            }
            this.lists = this.lists.map(d => {
              return Object.assign({}, d, {
                vs: !!this.compareIds.find(m => m.id === d.id)
              })
            })
            this.pages.sum = res.data.pages
            this.loading = false
          }
        })
    },
    loadingMore () {
      this.pages.now++
      this.getList()
    },
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeEventCollect(data)
        .then(res => {
          if (res.success) {
            this.lists.find(d => d.id === id).hasCollect = boolean
          } else {
            return new Error(res.message)
          }
        })
    },
    compareEvent (l) {
      let data = this.compareIds.slice()
      if (l.vs) {
        data = _.reject(data, d => d.id === l.id)
      } else {
        if (data.length > 1) {
          this.$message({
            message: '对比事件添加上限',
            type: 'warning',
            center: true
          })
          return false
        }
        data = data.concat(l)
      }
      this.$store.dispatch('updateCompareIds', data)
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/event_default.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.case-collection {
  padding-top: 40px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  nav {
    padding: 24px 40px 4px;
    background: #fff;
    border-radius: 4px;
    font-size: 12px;
    .times,
    .categories {
      display: flex;
      align-items: flex-start;
      label {
        min-width: 50px;
        margin-right: 30px;
        color: #999;
        margin-top: 6px;
      }
      .type {
        display: flex;
        flex-flow: row wrap;
      }
      div.label {
        min-width: 110px;
        text-align: center;
        margin-bottom: 20px;
      }
      span {
        display: inline-block;
        color: #666;
        padding: 6px 12px;
        border-radius: 13px;
        cursor: pointer;
        &.active {
          color: #fff;
          background-color: #347eee;
        }
      }
    }
  }
  .collect-content {
    height: 0;
    flex: 1;
    width: 100%;
    display: flex;
  }
  aside {
    min-width: 65px;
    margin-left: 20px;
    margin-top: 20px;
    font-size: 12px;
    color: #666;
    p.label {
      margin-bottom: 7px;
    }
    .times {
      margin-left: 12px;
      height: 28px;
      line-height: 28px;
      border-left: 1px solid #ccc;
      padding-left: 14px;
      position: relative;
      cursor: pointer;
      &.active {
        color: #3989cb;
        &::before {
          background-color: #3989cb;
        }
      }
      &::before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        transform: translate(-4px, -50%);
        width: 8px;
        height: 8px;
        background-color: #ccc;
        border-radius: 4px;
      }
    }
  }
  article {
    // flex: 1;
    // overflow-y: auto;
    margin-top: 20px;
    background: #fff;
    border-radius: 4px;
    position: relative;
    width: 100%;
    .loading {
      text-align: center;
      padding: 10px 0;
      color: #999;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaseCollection/CaseCollection.vue